import { useState } from 'react';
import Icon from '../components/ui/Icon.jsx';
import { useApi } from '../hooks/useApi.js';
import { getNews, getFeaturedNews, getUpcomingEvents } from '../api/newsApi.js';
import './NewsPage.css';

const TABS = ['全部', '業界新訊', '比賽資訊', '飛鏢知識', '選手專訪'];

function NewsPage() {
  const [activeTab, setActiveTab] = useState('全部');

  const { data: featured }  = useApi(() => getFeaturedNews(), []);
  const { data: news = [], loading } = useApi(() => getNews({ category: activeTab }), [activeTab]);
  const { data: events = [] } = useApi(() => getUpcomingEvents(), []);

  // 排除 featured 在卡片列表中
  const cards = news.filter(n => !featured || n.id !== featured.id);

  return (
    <main className="news">
      <div className="news-head">
        <h1>最新資訊<small>NEWS · INDUSTRY · COMPETITIONS</small></h1>
        <div className="news-tabs">
          {TABS.map(t => (
            <button
              key={t}
              className={`news-tab${activeTab === t ? ' on' : ''}`}
              onClick={() => setActiveTab(t)}
            >
              {t}
            </button>
          ))}
        </div>
      </div>

      {featured && activeTab === '全部' && (
        <article className="featured">
          <div>
            <div className="featured-meta">
              <span className="cat-chip">{featured.category}</span>
              <span className="cat-chip alt">{featured.date}</span>
              {featured.readTime && <span className="cat-chip alt">{featured.readTime}</span>}
            </div>
            <h2>{featured.title}</h2>
            <p>{featured.summary}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 18, position: 'relative', zIndex: 1 }}>
              <a className="read-more" href="#">閱讀全文 <Icon name="arrow" size={16} /></a>
              <span className="featured-byline">EDITOR · 道編輯部</span>
            </div>
          </div>
          <div className="featured-img">
            <svg viewBox="0 0 200 600"><use href="#dart-full" /></svg>
          </div>
        </article>
      )}

      <div className="cards">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => <div key={i} className="card-news" style={{ minHeight: 360, background: 'var(--ice)' }} />)
          : cards.length === 0
            ? <p style={{ gridColumn: '1 / -1', textAlign: 'center', padding: 48, color: 'var(--ink-soft)' }}>此分類下尚無文章。</p>
            : cards.map(c => (
                <article className="card-news" key={c.id}>
                  <div className={`card-pic${c.theme ? ' ' + c.theme : ''}`}>
                    <span className={`cat-chip${c.theme === 'gold' ? ' alt' : ''}`}>{c.category}</span>
                    <svg viewBox="0 0 200 600" style={{ height: '80%' }}><use href="#dart-full" /></svg>
                  </div>
                  <div className="card-body">
                    <div className="date">{c.date}{c.readTime ? ` · ${c.readTime}` : ''}</div>
                    <h3>{c.title}</h3>
                    <p>{c.summary}</p>
                    <a className="arr" href="#">繼續閱讀 →</a>
                  </div>
                </article>
              ))
        }
      </div>

      <section className="event-strip">
        <h3>近期賽事 <small>UPCOMING TOURNAMENTS</small></h3>
        <div className="event-list">
          {events.map((e, i) => (
            <div className="event" key={i}>
              <div className="event-date"><b>{e.day}</b><small>{e.month}</small></div>
              <div>
                <b>{e.title}</b>
                <p>{e.desc}</p>
                <div className="loc">📍 {e.loc}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default NewsPage;
